/*
* Header navigation for desktop and mobile
* */

(function () {
  var header = document.querySelector('.global-header');
  var lastScrollTop = 0;

  function showSubmenu(e) {
    e.preventDefault();
    e.stopPropagation();
    header.classList.add('submenu-active');
    // toggleVeil(true);
  }

  // Sub menu hide
  function hideSubmenu(e) {
    if (header.classList.contains('submenu-active')) {
      // toggleVeil();
      header.classList.add('submenu-hide');
      header.classList.remove('submenu-active');
      setTimeout(function () {
        header.classList.remove('submenu-hide');
      }, 600);
    }
  }

  // Mobile Navigation
  function showNavigation(e) {
    var nav = document.querySelector("#mobileNav");

    if (!nav.classList.contains('show')) {
      scrollLock();
      document.body.classList.add("js-menu-active");
      nav.classList.add('show');

    } else {
      document.body.classList.remove("js-menu-active");
      scrollUnlock();
      nav.classList.remove('show');
      hideSubmenu();
    }
    e.preventDefault();
    e.stopPropagation();
  }

  // Toggle veil
  function toggleVeil(show) {
    if (show) {
      document.body.classList.add('show-veil');
    } else {
      document.body.classList.remove('show-veil');
    }
  }

  function scrollLock() {
    lastScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    setTimeout(function () {
      document.body.classList.add('scroll-lock');
      document.querySelector('html').classList.add('scroll-lock');
    }, 100);
  }

  function scrollUnlock() {
    document.body.classList.remove('scroll-lock');
    document.querySelector('html').classList.remove('scroll-lock');
    setTimeout(function () {
      window.scrollTo(0, lastScrollTop);
    }, 100);
  }

  function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  // Init & nav event handlers
  function init() {
    var showSubMenuDesktop = document.querySelector(".global-header__menu__desktop .show-submenu");
    var showSubMenuMobile = document.querySelector(".global-header__mobile__menu__list .show-submenu");
    var mainContent = document.querySelector('#MainContent');
    var desktopMenu = document.querySelector('.global-header__menu__desktop');
    var globalSubmenu = document.querySelector('.global-header__submenu');


    const resizeObserver = new ResizeObserver(function() {
      var desktopMenuXPos = desktopMenu.getBoundingClientRect().x;

      if (window.innerWidth >= 990) {
        globalSubmenu.style.left = desktopMenuXPos - 40 + "px";
      } else {
        globalSubmenu.style.left = '0px';
      }
    });

    resizeObserver.observe(document.getElementById('MainContent'));

    document.querySelector(".global-header__menu_burger").addEventListener("click", showNavigation);
    document.querySelector(".global-header__back").addEventListener("click", hideSubmenu);

    showSubMenuDesktop && showSubMenuDesktop.addEventListener('mouseover', showSubmenu);
    showSubMenuMobile && showSubMenuMobile.addEventListener('click', showSubmenu);

    document.querySelector(".global-header__menu__desktop .link:not(.show-submenu)").addEventListener("mouseover", hideSubmenu);
    if (mainContent) {
      mainContent.addEventListener("click", hideSubmenu);
      mainContent.addEventListener("mouseover", hideSubmenu);
    }
    document.querySelectorAll('.shopify-currency-form select').forEach(function (item) {
      item.addEventListener('change', currencyFormSubmit);
    });

    if (parseInt(document.querySelector('#CartCount').innerText, 10) > 0) {
      leavingModals.leavingHandlers();
    }
  }

  init();

})();